import type { CompanyBaseInfo } from "app/pages/sales-intelligence/modules/company-analysis/types/company";
import type { SignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";

import AdNetworkSignalEventInfo from "./AdNetworkSignalEventInfo";
import IntentSignalEventInfo from "./IntentSignalEventInfo/IntentSignalEventInfo";
import NewsSignalEventInfo from "./NewsSignalEventInfo";
import TechnologySignalEventInfo from "./TechnologySignalEventInfo";
import TrafficSignalEventInfo from "./TrafficSignalEventInfo";

type SignalEventInfoProps = {
    signal: SignalEventDto;
    companyInfo?: CompanyBaseInfo;
    onCompanyLinkClick: (signalEvent: SignalEventDto) => void;
    onShowDescriptionClick: () => void;
};

const SignalEventInfo = ({ signal, companyInfo, onCompanyLinkClick, onShowDescriptionClick }: SignalEventInfoProps) => {
    const { type } = signal;

    const companyName = companyInfo?.name || "";

    if (type === SignalType.Intent) {
        return <IntentSignalEventInfo signal={signal} />;
    }

    if (type === SignalType.News) {
        return (
            <NewsSignalEventInfo
                signal={signal}
                onCompanyLinkClick={onCompanyLinkClick}
                onShowDescriptionClick={onShowDescriptionClick}
                data-automation="signal-event-info-news"
            />
        );
    }
    if (type === SignalType.Technology) {
        return (
            <TechnologySignalEventInfo
                signal={signal}
                companyName={companyName}
                data-automation="signal-event-info-technology"
            />
        );
    }
    if (type === SignalType.AdNetwork) {
        return (
            <AdNetworkSignalEventInfo
                signal={signal}
                companyName={companyName}
                data-automation="signal-event-info-ad-network"
            />
        );
    }

    if (type === SignalType.Traffic) {
        return <TrafficSignalEventInfo signal={signal} />;
    }

    return null;
};

export default SignalEventInfo;
